module.exports = __webpack_public_path__ + "static/media/CateringBussiness.2cd42d89.png";